import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import RegisterClub from './components/RegisterClub';
import Dashboard from './components/Dashboard';
import ClubDashboard from './components/ClubDashboard';
import ClubSettings from './components/ClubSettings';
import ClubEdit from './components/ClubEdit';
import ClubStatement from './components/ClubStatement';
import ClubFund from './components/ClubFund';
import ClubWithdrawals from './components/ClubWithdrawals';
import ClubInvite from './components/ClubInvite';
import ClubBroadcast from './components/ClubBroadcast';
import ClubGoals from './components/ClubGoals';
import ClubSubscription from './components/ClubSubscription';
import ClubPendingBets from './components/ClubPendingBets';
import PersonalBookie from './components/PersonalBookie';
import ClubHistory from './components/ClubHistory';
import Competitions from './components/Competitions';
import Achievements from './components/Achievements';
import ResetPassword from './components/ResetPassword';
import ClubMembers from './components/ClubMembers';
import LinkBookie from './components/LinkBookie';
import LinkBookieComplete from './components/LinkBookieComplete';
import BookieCallback from './components/BookieCallback';
import Settings from './components/Settings';
import PersonalDetails from './components/settings/PersonalDetails';
import SecurityDetails from './components/settings/SecurityDetails';
import ProfileImage from './components/settings/ProfileImage';
import NotificationSettings from './components/settings/NotificationSettings';
import ManageSubscriptions from './components/settings/ManageSubscriptions';
import BookieAccounts from './components/settings/BookieAccounts';
import ReferMates from './components/settings/ReferMates';
import LeaveClub from './components/settings/LeaveClub';
import ClubLotto from './components/ClubLotto';
import PublicLottery from './components/PublicLottery';
import InviteAccept from './components/InviteAccept';
import SignupInvite from './components/SignupInvite';
import SignupFund from './components/SignupFund';
import { authAPI } from './services/api';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';

function ProtectedRoute({ children }) {
  return authAPI.isAuthenticated() ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <ThemeProvider>
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/register/club" element={<ProtectedRoute><RegisterClub /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/dashboard/:clubId" element={<ProtectedRoute><ClubDashboard /></ProtectedRoute>} />
          <Route path="/lottery" element={<ProtectedRoute><PublicLottery /></ProtectedRoute>} />

          {/* Club settings pages — sidebar layout */}
          <Route path="/club/:clubId" element={<ProtectedRoute><ClubSettings /></ProtectedRoute>}>
            <Route path="edit" element={<ClubEdit />} />
            <Route path="statement" element={<ClubStatement />} />
            <Route path="fund" element={<ClubFund />} />
            <Route path="withdrawals" element={<ClubWithdrawals />} />
            <Route path="members" element={<ClubMembers />} />
            <Route path="invite" element={<ClubInvite />} />
            <Route path="broadcast" element={<ClubBroadcast />} />
            <Route path="goals" element={<ClubGoals />} />
            <Route path="subscription" element={<ClubSubscription />} />
            <Route path="pending-bets" element={<ClubPendingBets />} />
            <Route path="bookie" element={<PersonalBookie />} />
            <Route path="history" element={<ClubHistory />} />
            <Route path="lotto" element={<ClubLotto />} />
            <Route path="competitions" element={<Competitions />} />
            <Route path="achievements" element={<Achievements />} />
            <Route index element={<Navigate to="edit" replace />} />
          </Route>

          {/* Signup onboarding steps */}
          <Route path="/signup/invite" element={<ProtectedRoute><SignupInvite /></ProtectedRoute>} />
          <Route path="/signup/fund" element={<ProtectedRoute><SignupFund /></ProtectedRoute>} />

          {/* Bookie linking */}
          <Route path="/register/link" element={<ProtectedRoute><LinkBookie /></ProtectedRoute>} />
          <Route path="/register/link/complete" element={<ProtectedRoute><LinkBookieComplete /></ProtectedRoute>} />
          <Route path="/bookie/callback" element={<ProtectedRoute><BookieCallback /></ProtectedRoute>} />

          {/* Account settings — sidebar layout */}
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>}>
            <Route path="personal" element={<PersonalDetails />} />
            <Route path="security" element={<SecurityDetails />} />
            <Route path="profile-image" element={<ProfileImage />} />
            <Route path="notifications" element={<NotificationSettings />} />
            <Route path="subscriptions" element={<ManageSubscriptions />} />
            <Route path="bookie-accounts" element={<BookieAccounts />} />
            <Route path="refer" element={<ReferMates />} />
            <Route path="start-club" element={<Navigate to="/register/club" replace />} />
            <Route path="leave-club" element={<LeaveClub />} />
            <Route index element={<Navigate to="personal" replace />} />
          </Route>

          {/* Invite accept — public page, auth optional */}
          <Route path="/invite/:token" element={<InviteAccept />} />

          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
    </ThemeProvider>
  );
}

export default App;
